import styled from "styled-components";

export const ContainerModalInfoMensagens = styled.div`
  display: flex;
  flex-direction: column;
  padding: 3rem 5rem;
  gap: 2rem;
  background-color: transparent;

  .modal-header1 {
    text-align: center;
    padding-bottom: 1rem;
  }

  .texto {
    text-align: justify;
    line-height: 1.6;
    color: ${(props) => props.theme.colors.tertiary};

    p {
      margin: 0 0 1.4rem 0;

      &:last-child {
        margin-bottom: 0;
      }
    }

    strong {
      font-weight: bold;
    }
  }

  .botoes {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 3rem;

    .cancelar {
      color: ${(props) => props.theme.colors.tertiary};
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      svg {
        fill: ${(props) => props.theme.colors.tertiary};
        transform: rotate(90deg);
      }
    }

    .disabled {
      opacity: 0.7 !important;
    }
  }
`;
